import { render, staticRenderFns } from "./gitHubRepoStream.vue?vue&type=template&id=22d8334f&"
import script from "./gitHubRepoStream.vue?vue&type=script&lang=js&"
export * from "./gitHubRepoStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports